module.exports = __webpack_public_path__ + "img/small-report-bg.8864a7f1.png";